import React, { useState, useEffect } from "react";

export default function Timer(props) {
  const { maxTime = 10, hideMinutes = false, hideHours = false, hideSeconds = false, handleTimeOver } = props;
  const [timeLeft, setTimeLeft] = useState(maxTime);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);
    if (timeLeft <= 0) {
      clearInterval(intervalId);
      handleTimeOver();
    }
    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const hours = Math.floor(timeLeft / 3600).toString();
  const minutes = Math.floor((timeLeft % 3600) / 60).toString();
  const seconds = (timeLeft % 60).toString();

  return (
    <div>
      {!hideHours && hours.padStart(2, "0") + ":"}
      {!hideMinutes && minutes.padStart(2, "0")}:{!hideSeconds && seconds.padStart(2, "0")}
    </div>
  );
}
